import { useSyncExternalStore } from "react";
import { storageKey } from "../config";
import type { LibraryItem } from "./Viewer";

type Change = { seriesId: string; title: string; saved?: boolean; progress?: { episode: number; seconds: number } | null };
const key = storageKey("local-library");
const eventName = "yestv:local-library";
function read(): LibraryItem[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(key) || "[]");
    if (!Array.isArray(value)) return [];
    return value.filter(item => item && typeof item.seriesId === "string" && typeof item.title === "string" && typeof item.saved === "boolean" && (item.progress === null || (Number.isInteger(item.progress?.episode) && item.progress.episode > 0 && Number.isFinite(item.progress.seconds) && item.progress.seconds >= 0 && item.progress.seconds <= 86400 && Number.isFinite(item.progress.updatedAt)))).slice(0, 200);
  } catch { return []; }
}
let items = read();
function subscribe(listener: () => void) {
  const storage = (event: StorageEvent) => { if (event.key === key || event.key === null) { items = read(); listener(); } };
  addEventListener("storage", storage); addEventListener(eventName, listener);
  return () => { removeEventListener("storage", storage); removeEventListener(eventName, listener); };
}
export function useLocalLibrary() { return useSyncExternalStore(subscribe, () => items); }
export async function changeLocalItem(change: Change) {
  const previous = items.find(item => item.seriesId === change.seriesId) || { seriesId: change.seriesId, title: change.title, saved: false, progress: null };
  const next = { ...previous, ...change, progress: change.progress === undefined ? previous.progress : change.progress === null ? null : { ...change.progress, updatedAt: Date.now() } };
  const updated = [next, ...items.filter(item => item.seriesId !== change.seriesId)].filter(item => item.saved || item.progress);
  if (updated.filter(item => item.saved).length > 100) throw new Error("最多收藏100部，请先取消部分收藏。");
  let history = 0;
  const trimmed = updated.map(item => item.progress && ++history > 100 ? { ...item, progress: null } : item).filter(item => item.saved || item.progress);
  try { localStorage.setItem(key, JSON.stringify(trimmed)); }
  catch { throw new Error("无法保存到浏览器本地，请检查网站存储设置。"); }
  items = trimmed; dispatchEvent(new Event(eventName));
}
